export default "__VITE_ASSET__c85aa748__"